import { useQuery } from '@tanstack/react-query';
import { getDevices } from '@/api/devices';
import type { DeviceFilters, DevicesResponseData } from '@/api/devices/types';

/**
 * React Query hook for fetching devices
 * Handles error cases and ensures we never return undefined
 */
export function useDevices(filters?: DeviceFilters) {
  return useQuery<DevicesResponseData, Error>({
    queryKey: ['devices', filters],
    queryFn: async () => {
      try {
        return await getDevices(filters);
      } catch (error) {
        console.error('Error in useDevices hook:', error);
        throw error;
      }
    },
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}